import type { ListMbcAdminAssignmentsResponse } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { mbcAdminKeys } from "@/hooks/queryKeys";

import { listAssignments } from "../api";

export function useAssignments(): UseQueryResult<
  ListMbcAdminAssignmentsResponse,
  Error
> {
  return useQuery({
    queryFn: listAssignments,
    queryKey: mbcAdminKeys.assignments(),
  });
}
